export default __webpack_public_path__ + "0abbf97ce24a59dace8011fdc2c29d67.png";